import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from '@/App'
import { ThemeProvider } from '@/lib/ThemeContext'
import { ToastProvider } from '@/ui/Toast'
import '@/styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
